import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

// Skickar GA4 page_view vid varje route-byte (SPA). Initial config i public/index.html
// har send_page_view:false så att denna hook är den enda källan (ingen dubbelräkning).
export default function RoutePageViews() {
  const location = useLocation();
  const firstPage = useRef(true);
  const lastPath = useRef(null);
  const [analyticsReady, setAnalyticsReady] = useState(false);

  // GA injiceras först efter cookie-samtycke – skicka då aktuell sida direkt
  useEffect(() => {
    const onReady = () => {
      lastPath.current = null;
      setAnalyticsReady((v) => !v);
    };
    window.addEventListener("sfv-analytics-ready", onReady);
    return () => window.removeEventListener("sfv-analytics-ready", onReady);
  }, []);

  useEffect(() => {
    if (typeof window.gtag !== "function") return;

    const pagePath = `${location.pathname}${location.search}${location.hash}`;
    if (lastPath.current === pagePath) return; // spärr mot dubbla events (t.ex. StrictMode i dev)
    lastPath.current = pagePath;

    window.gtag("event", "page_view", {
      page_title: document.title,
      page_location: `${window.location.origin}${pagePath}`,
      page_path: pagePath,
    });

    if (!firstPage.current) window.scrollTo(0, 0);
    firstPage.current = false;
  }, [location.pathname, location.search, location.hash, analyticsReady]);

  return null;
}
